import { Close, PrintOutlined } from '@mui/icons-material'
import { Alert, AlertTitle, Box, Button, IconButton, Stack } from '@mui/material'
import { FunctionComponent } from 'react'

export interface TrabajoAvisoItem {
  jobId: string
  titulo: string
  impresora: string
  /** Ej. "sin papel", "sigue en cola" */
  motivo: string
  /** Hay documento para imprimir en otra impresora */
  puedeReimprimir: boolean
  /** El agente aún puede detener el trabajo */
  cancelable: boolean
}

interface Props {
  items: TrabajoAvisoItem[]
  ocupado: string | null
  onCancelar: (jobId: string) => void
  onImprimirEnOtra: (jobId: string) => void
  onOcultar: (jobId: string) => void
}

/**
 * Trabajos aceptados por isi-print que quedaron detenidos (sin papel, apagada, en cola...).
 * Quedan visibles hasta resolverse: al reponer el papel se imprimen solos. Se apilan abajo a la
 * izquierda, a todo el ancho en móvil.
 */
const IsiPrintTrabajosAviso: FunctionComponent<Props> = ({
  items,
  ocupado,
  onCancelar,
  onImprimirEnOtra,
  onOcultar,
}) => {
  if (!items.length) return null
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 16,
        right: { xs: 16, sm: 'auto' },
        bottom: 16,
        width: { sm: 380 },
        zIndex: (t) => t.zIndex.snackbar,
      }}
    >
      <Stack spacing={1}>
        {items.map((t) => (
          <Alert
            key={t.jobId}
            severity="warning"
            variant="filled"
            icon={<PrintOutlined />}
            sx={{ '& .MuiAlert-message': { flex: 1, minWidth: 0 } }}
            action={
              <IconButton
                size="small"
                color="inherit"
                aria-label="Ocultar"
                onClick={() => onOcultar(t.jobId)}
              >
                <Close fontSize="small" />
              </IconButton>
            }
          >
            <AlertTitle sx={{ mb: 0 }}>{t.titulo} sin imprimir</AlertTitle>
            {t.impresora}: {t.motivo}. Se imprimirá al resolverlo.
            <Stack direction="row" spacing={1} useFlexGap sx={{ mt: 1, flexWrap: 'wrap' }}>
              {t.cancelable && (
                <Button
                  size="small"
                  color="inherit"
                  variant="outlined"
                  loading={ocupado === t.jobId}
                  disabled={!!ocupado}
                  onClick={() => onCancelar(t.jobId)}
                >
                  Cancelar
                </Button>
              )}
              {t.puedeReimprimir && (
                <Button
                  size="small"
                  color="inherit"
                  variant="outlined"
                  disabled={!!ocupado}
                  onClick={() => onImprimirEnOtra(t.jobId)}
                >
                  {t.cancelable ? 'Cancelar e imprimir en otra' : 'Imprimir en otra'}
                </Button>
              )}
            </Stack>
          </Alert>
        ))}
      </Stack>
    </Box>
  )
}

export default IsiPrintTrabajosAviso
